import { defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core'
import paintShopRepository from '@/components/paintshop/model/PaintShopRepository.ts'
import { useAuthorizationStore } from '@/components/authorization/model/AuthorizationRepository.ts'
import constructionSystemRepository from '@/components/construction/system/model/ConstructionSystemRepository.ts'
import { contractorRepository } from '@/components/contractor/model/ContractorRepository.ts'
import { IContractor, IPaintShop, ISystemStep, ISystemStepConfiguration } from '@/service/api'
import configurationRepository from '@/components/config/model/ConfigurationRepository.ts'

// TODO Vue on Mounted error due to useLocalStorage from vueUse
export const useGlobalStateStore = defineStore('globalStateStore', {
  state: () => ({
    possibleSystemSteps: useLocalStorage('globalStateStore.possibleSystemSteps', [] as ISystemStepConfiguration[]),
    paintShops: useLocalStorage('globalStateStore.paintShops', [] as IPaintShop[]),
    selectedPaintShopId: useLocalStorage('globalStateStore.selectedPaintShopId', '' as string),
    contractors: useLocalStorage('globalStateStore.contractors', [] as IContractor[]),
    openMobileScanner: false as boolean,
    mobileScannerDisabled: useLocalStorage('globalStateStore.mobileScannerDisabled', false as boolean),
    backendVersion: useLocalStorage('globalStateStore.backendVersion', '' as string)
  }),
  getters: {
    getUserPaintShopsAsOptions (): { value: string, label: string }[] {
      const paintShopIds = useAuthorizationStore().getPaintShopsForLoggedUser
      return paintShopIds.map(id => ({ value: id, label: this.paintShops.find(p => p.id === id)?.shopName || id }))
    }
  },

  actions: {
    async loadContractors () {
      await contractorRepository.getAll().then(
        contractors => {
          this.contractors = contractors
        }
      )
    },
    openScanner (): void {
      this.openMobileScanner = true
    },
    closeScanner (): void {
      this.openMobileScanner = false
    },
    init (): void {
      paintShopRepository.fetchAll()
        .then(
          paintShops => {
            this.paintShops = paintShops
          }
        )
      constructionSystemRepository.getPossibleSystemSteps().then(
        steps => {
          this.possibleSystemSteps = steps.filter((step) => step.selectable)
        }
      )
      this.loadContractors().then()
      configurationRepository.isMobileScannerDisabled().then((disabled) => {
        this.mobileScannerDisabled = disabled
      })
    },
    clearLocalStorage (): void {
      this.selectedPaintShopId = ''
      this.paintShops = []
      this.possibleSystemSteps = []
      this.contractors = []
    },
    getStepConfiguration (stepType: ISystemStep) : ISystemStepConfiguration {
      return this.possibleSystemSteps.find(step => step.step === stepType)!
    },
    setVersion (version: string) {
      this.backendVersion = version
    }

  }
})


